'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CatalogueResults = require('./components/CatalogueResults.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogueResults).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-results/components/catalogue-results/index.js
// module id = 981
// module chunks = 1